package uz.ferro.erp.util

import uz.ferro.erp.Colors
import uz.ferro.erp.feature.order.model.OrderStatus
import uz.ferro.erp.feature.task.model.TargetType
import web.cssom.BackgroundColor
import kotlin.text.Typography.nbsp

fun Int?.formatGrouped(): String {
    this ?: return ""
    val inp = this.toString()
    if (this < 10_000) return inp

    var i = inp.length
    var out = ""
    while (i > 0) {
        if (out.isNotBlank()) {
            out = nbsp + out
        }
        out = inp.substring((i - 3).coerceAtLeast(0), i) + out
        i -= 3
    }
    return out
}

fun Double?.formatPrice(): String {
    this ?: return ""
    val out = this.toString()
    val decimalPointIndex = out.indexOfLast { it == '.' || it == ',' }
    var decimalPart = ""
    var intPart = out

    // TODO use more right solution for fix precision issues
    if (decimalPointIndex != -1) {
        decimalPart = out.substring(decimalPointIndex + 1)
        intPart = out.substring(0, decimalPointIndex)
    }

    if (decimalPart.isNotBlank()) {
        val seqZeroIndex = decimalPart.indexOf("00000")
        val seqNineIndex = decimalPart.indexOf("99999")
        if (seqZeroIndex != -1) {
            decimalPart = decimalPart.substring(0, seqZeroIndex)
        } else if (seqNineIndex != -1) {
            decimalPart = decimalPart.substring(0, seqNineIndex)
            val decimalPartInt = (decimalPart.toInt() + 1).toString()
            if (decimalPartInt.length > decimalPart.length) {
                decimalPart = ""
                intPart = (intPart.toInt() + 1).toString()
            } else {
                decimalPart = decimalPartInt
            }
        }
    }

    intPart = intPart.toIntOrZero().formatGrouped()

    return if (decimalPart.isNotBlank()) {
        "$intPart.$decimalPart"
    } else {
        intPart
    }
}

fun Pair<Double?, Int?>.formatPrice(currency: String): String {
    val priceFormatted = first.formatPrice()
    if (priceFormatted.isNotBlank() && priceFormatted != "$0" && priceFormatted != "$0.0" && priceFormatted != "$0,0") {
        return priceFormatted
    }
    return second.formatWithCurrency(currency)
}

fun Int?.formatWithCurrency(currency: String): String = formatGrouped().withSuffix(currency)

fun Double?.formatLocalCurrency(): String {
    return this.formatPrice().withSuffix("so‘m")
}

fun Any?.withSuffix(suffix: String?): String {
    this ?: return ""
    if (this.toString().isBlank()) return ""
    if (suffix.orEmpty().isBlank()) return this.toString()
    return "$this$nbsp$suffix"
}

fun OrderStatus?.displayText(): String {
    return when (this) {
        OrderStatus.NEW -> "Yangi"
        OrderStatus.PENDING_MANUAL -> "Ko'rib chiqilishi kutilmoqda"
        OrderStatus.RESERVE_PENDING -> "Band qilinishi kutilmoqda"
        OrderStatus.RESERVED -> "Band qilindi"
        OrderStatus.RESERVE_FAILED -> "Band qilishda muammo"
        OrderStatus.PAYMENT_PENDING -> "To'lov kutilmoqda"
        OrderStatus.PAYMENT_SUCCESS -> "To'landi"
        OrderStatus.PAYMENT_FAILED -> "To'lovda muammo"
        OrderStatus.COMPLETE_PENDING -> "Tugallash kutilmoqda"
        OrderStatus.COMPLETED -> "Tayyor"
        OrderStatus.REJECTED -> "Rad etildi"
        OrderStatus.CANCELLED -> "Bekor qilindi"
        else -> ""
    }
}

fun OrderStatus?.displayShortText(): String {
    return when (this) {
        OrderStatus.NEW -> "Yangi"
        OrderStatus.PENDING_MANUAL -> "Pending"
        OrderStatus.RESERVE_PENDING -> "R. Pend"
        OrderStatus.RESERVED -> "Band qilindi"
        OrderStatus.RESERVE_FAILED -> "R. FAILED"
        OrderStatus.PAYMENT_PENDING -> "Pay. Pend"
        OrderStatus.PAYMENT_SUCCESS -> "To'landi"
        OrderStatus.PAYMENT_FAILED -> "Pay. Failed"
        OrderStatus.COMPLETE_PENDING -> "Com. Pend"
        OrderStatus.COMPLETED -> "Tayyor"
        OrderStatus.REJECTED -> "Rad etildi"
        OrderStatus.CANCELLED -> "Bekor qilindi"
        else -> ""
    }
}

fun OrderStatus?.rowColor(): BackgroundColor? {
    return when (this) {
        OrderStatus.NEW -> Colors.bg_os_new
        OrderStatus.PENDING_MANUAL -> Colors.bg_os_pend
        OrderStatus.RESERVE_PENDING -> Colors.bg_os_res_pend
        OrderStatus.RESERVED -> Colors.bg_os_reserved
        OrderStatus.RESERVE_FAILED -> Colors.bg_os_res_fail
        OrderStatus.PAYMENT_PENDING -> Colors.bg_os_pay_pend
        OrderStatus.PAYMENT_SUCCESS -> Colors.bg_os_pay_success
        OrderStatus.PAYMENT_FAILED -> Colors.bg_os_pay_fail
        OrderStatus.COMPLETE_PENDING -> Colors.bg_os_com_pend
        OrderStatus.COMPLETED -> Colors.bg_os_completed
        OrderStatus.COMPLETE_FAILED -> Colors.bg_os_com_fail
        OrderStatus.REJECTED -> Colors.bg_os_rejected
        OrderStatus.CANCELLED -> Colors.bg_os_canceled
        else -> null
    }
}

fun OrderStatus?.descriptionText(): String {
    return when (this) {
        else -> ""
    }
}

fun TargetType?.displayText(): String {
    return when (this) {
        TargetType.INVOICE -> "Xarid"
        else -> ""
    }
}